import { EmbedConfig, MemberInterface, TakeoverEventPayload, TakeoverEventType } from "@swivl-mono/types";
import React, { Component } from "react";

import { Config } from "../../../../Config/Config";
import { ListItemData } from "../../ListItem";
import "./TakeoverEvent.scss";

export interface TakeoverEventProps {
  item: ListItemData;
}

export class TakeoverEvent extends React.Component<TakeoverEventProps> {
  render() {
    const config = Config;
    const payload = (this.props.item as any).message.payload as TakeoverEventPayload;
    const member: MemberInterface | undefined = payload.member;
    var avatarURL, text;
    if (payload.type === TakeoverEventType.TAKEOVER_STARTED) {
      avatarURL = member?.agentAvatarURL || "https://swivl-cdn.s3-us-west-1.amazonaws.com/avatar-generic.png";
      text = member?.agentName ? member?.agentName + " has entered the conversation" : "an agent has entered the conversation";
    } else {
      avatarURL = config?.avatarURL ? config.avatarURL : "https://swivl-cdn.s3-us-west-1.amazonaws.com/avatar-generic.png";
      const botName = config?.botName ? config.botName : "the bot";
      text = "you're now chatting with " + botName;
    }

    return (
      <div className="scc-TakeoverEvent">
        <div className="scc-TakeoverEvent-avatarWrapper">
          <img src={avatarURL} width="40" height="40" />
        </div>
        <div className="text-sm text-grey-600 leading-4 swivl-timestamp">{text}</div>
      </div>
    );
  }
}
